<template>
  <div>
    <a 
      v-if="url"
      :href="url"
    >
      {{url}}
    </a>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({
    url: null
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const body = {
        workspaceID: 'f8cf5119-3c6c-42a6-8bdb-e2a012251894'
      }
      axios.post('http://dtouch.local:3803/v1/public/stripe/', body)
        .then(response => {
          this.url = response.data.url
        })
        .catch (error => {
          console.log('error', error)
        })
    }
  }
}
</script>

